import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { OPTIONAL } from 'utils/asset/completionModes';
import filterObject from 'utils/filterObject';
export function formatPlaylistSubmissionData(_ref) {
  var _fields$externalRefId;
  var playlistForm = _ref.playlistForm,
    parentPlaylistId = _ref.parentPlaylistId,
    isEditMode = _ref.isEditMode;
  var fields = playlistForm.fields;
  var playlistData = {
    description: fields.description.changedValue,
    tags: fields.tags.changedValue,
    topics: fields.topics.changedValue,
    thumbnailId: fields.thumbnailId.changedValue,
    allow_member_contributions: fields.memberContributions.value,
    badge: fields.badge.changedValue,
    parentPlaylistId: fields.completionMode.wasChanged ? parentPlaylistId : undefined,
    externalRefId: fields.externalRefId.wasChanged ? ((_fields$externalRefId = fields.externalRefId.value) === null || _fields$externalRefId === void 0 ? void 0 : _fields$externalRefId.trim()) || null : undefined
  };
  if (isEditMode) {
    playlistData = _objectSpread(_objectSpread({}, playlistData), {}, {
      allow_member_contributions: fields.memberContributions.changedValue,
      playlist_numbering: fields.displayContentNumbers.changedValue,
      name: fields.name.changedValue,
      locale: fields.locale.changedValue,
      optional: fields.completionMode.wasChanged ? fields.completionMode.value === OPTIONAL : undefined
    });
  } else {
    playlistData = _objectSpread(_objectSpread({}, playlistData), {}, {
      name: fields.name.value,
      locale: fields.locale.value
    });
  }

  // ensure we only send dirty payload
  var cleanedPlaylistData = filterObject(playlistData);
  return cleanedPlaylistData;
}